import React from 'react';
import { Action } from '@interstate/components/Action';
import { Typography } from '@interstate/components/Typography';

interface CustomerActionButtonProps {
    onClick: () => void;
    dataTestId: string;
    disabled?: boolean;
}

const CustomerInboxButton: React.FC<CustomerActionButtonProps> = ({ onClick, dataTestId, disabled = false }) => {
    return (
        <Typography
            variant="h3"
            tag="span"
            sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '.4rem',
                alignItems: 'center',
                whiteSpace: 'nowrap',
                marginTop: '2px'
            }}
        >
            <Action size="md" data-testid={dataTestId} onClick={onClick} disabled={disabled}>
                <span style={{ fontWeight: 400 }}>Inbox</span>
            </Action>
        </Typography>
    );
};

export default CustomerInboxButton;
